import { render, staticRenderFns } from "./mycurriculum.vue?vue&type=template&id=62947318&scoped=true"
import script from "./mycurriculum.vue?vue&type=script&lang=js"
export * from "./mycurriculum.vue?vue&type=script&lang=js"
import style0 from "./mycurriculum.vue?vue&type=style&index=0&id=62947318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62947318",
  null
  
)

export default component.exports